import { gql } from "@outschool/ui-apollo";
import { ListingCardFragment } from "@outschool/ui-components-website";

import { SectionFragment } from "../../../queries/SectionFragments";

export const ParentDashboardListingsByActivityUids = gql`
  query ParentDashboardListingsByActivityUids(
    $activityUids: [ID!]!
    $skipRating: Boolean!
    $withRecentReviews: Boolean!
  ) {
    listingsByActivityUids(activityUids: $activityUids) {
      ...ListingCard_listing
      activity {
        paginatedFilteredSections(filter: Bookable) {
          data {
            filledSpaceCount
            ...SectionFragment
          }
        }
      }
    }
  }
  ${ListingCardFragment}
  ${SectionFragment}
`;
